import { useMemo } from 'react';
import {
	RateSheetGeneratorIndexRequest,
	RateSheetGeneratorIndexResponse
} from 'RtModels';
import { RateManagementRouter } from 'RtUi/app/AccountManagement/RateManagement/RateManagement.router';
import { useGetRateSheetGenerators } from 'RtUi/app/AccountManagement/RateSheetGenerator/libs/services';
import { RateSheetGeneratorRouter } from 'RtUi/app/AccountManagement/RateSheetGenerator/RateSheetGenerator.router';
import DataGrid from 'RtUi/components/data/DataGrid';
import { getRateSheetGeneratorColumns } from 'RtUi/components/data/DataGrid/configurations/accountManagement/rateSheetGenerator';

interface IRateSheetGeneratorGridProps {
	resourceParams?: RateSheetGeneratorIndexRequest;
	autoFocusFilter?: boolean;
}

export const RateSheetGeneratorDataGrid = ({
	resourceParams
}: IRateSheetGeneratorGridProps) => {
	const { data, isFetching: isLoading } =
		useGetRateSheetGenerators(resourceParams);
	const columns = useMemo(() => getRateSheetGeneratorColumns(), []);

	return (
		<DataGrid<RateSheetGeneratorIndexResponse>
			data={data?.data}
			columns={columns}
			totalRows={data?.totalCount}
			loading={isLoading}
			pageName={'rateSheetGenerator_generators'}
			router={RateSheetGeneratorRouter}
		/>
	);
};
